import { render, staticRenderFns } from "./push-notifications-registration-page.vue?vue&type=template&id=0ab30957&scoped=true"
import script from "./push-notifications-registration-page.vue?vue&type=script&lang=js"
export * from "./push-notifications-registration-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab30957",
  null
  
)

export default component.exports